import { render } from "./ItemReviews.vue?vue&type=template&id=336441fc"
import script from "./ItemReviews.vue?vue&type=script&lang=js"
export * from "./ItemReviews.vue?vue&type=script&lang=js"

import "./ItemReviews.vue?vue&type=style&index=0&id=336441fc&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__